import { render } from "./GridLoading.vue?vue&type=template&id=d867a76c&ts=true"
import script from "./GridLoading.vue?vue&type=script&lang=ts"
export * from "./GridLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__